
import { Component, Prop, Vue } from 'vue-property-decorator';
import Swal from 'sweetalert2';

@Component
export default class DeleteItemButton extends Vue {
    @Prop({ type: Object, required: true }) readonly item!: any;
    @Prop({ type: String, required: true }) readonly entity!: string;
    @Prop({ type: Boolean, default: true }) readonly loadAfterDelete!: boolean;

    loading: boolean = false;

    async confirmDelete() {
        const result = await Swal.fire({
            title: '¿Está seguro?',
            html: `Esto eliminará este item`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, ¡Eliminar!',
            cancelButtonText: '¡No!',
            cancelButtonColor: '#FF5252',
            showCloseButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                try {
                    const response = await this.$store.dispatch({
                        type: this.entity + '/delete',
                        data: this.item
                    });
                    return response;
                } catch (error) {
                    Swal.showValidationMessage("No se pudo eliminar");
                    throw error;
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        });

        if (result.value) {
            if (this.loadAfterDelete && (this.$store as any)._actions[this.entity + '/getpage']) {
                await this.$store.dispatch({ type: this.entity + '/getpage' });
            }
            this.$emit('deleted', this.item);
            Swal.fire('Eliminado', 'Has eliminado este registro correctamente', 'success');
        }
    }
}
